import { create } from "zustand";
import { Modo } from "../theme";

const LS_KEY = "dcc-tema";

/** Modo inicial: lo guardado, o la preferencia del sistema. */
export function modoInicial(): Modo {
  const guardado = localStorage.getItem(LS_KEY);
  if (guardado === "light" || guardado === "dark") return guardado;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

/** Aplica el modo al <html> (fija `data-theme`, que selecciona las variables CSS). */
function aplicar(modo: Modo) {
  document.documentElement.dataset.theme = modo;
  localStorage.setItem(LS_KEY, modo);
}

interface TemaState {
  modo: Modo;
  alternar: () => void;
  setModo: (modo: Modo) => void;
}

export const useTema = create<TemaState>((set) => ({
  modo: modoInicial(),
  alternar: () =>
    set((s) => {
      const modo: Modo = s.modo === "dark" ? "light" : "dark";
      aplicar(modo);
      return { modo };
    }),
  setModo: (modo) => {
    aplicar(modo);
    set({ modo });
  },
}));
